import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { switchMap, filter, take, catchError } from 'rxjs/operators';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(public authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //checking accesstoken in session storage
    if (sessionStorage.getItem('access_token') && request.url.indexOf('youtube') === -1) {
      this.checkSessionId();
      request = this.addToken(request, sessionStorage.getItem('access_token') || '');
    }

    //checking error
    return next.handle(request).pipe(catchError(error => {
      return throwError(error);
    }));
  }


  //authorization header
  private addToken(request: HttpRequest<any>, token: string) {
    if (request.url.indexOf('youtube') !== -1) {
      return request
    }
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }


  private checkSessionId() {
    let date = new Date();
    if(!sessionStorage.getItem('sessionId')) {
      sessionStorage.setItem('sessionId', this.uuid4());
    }
    if (sessionStorage.getItem('timeId') &&  parseInt(sessionStorage.getItem('timeId') || '0') < date.getTime()) {
      sessionStorage.setItem('timeId', (date.getTime() + 60 * 60 * 1000).toString())
      sessionStorage.setItem('sessionId', this.uuid4());
    } else {
      sessionStorage.setItem('timeId', (date.getTime() + 60 * 60 * 1000).toString());
    }
  }

  uuid4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
  }

}